import dJSON from 'dirty-json';
import Splide from '@splidejs/splide';

const moduleSelector = '.services-slider';

const arrowSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" aria-hidden="true"><path d="M28.061 17.0612L19.061 26.0612C18.7792 26.343 18.397 26.5013 17.9985 26.5013C17.6 26.5013 17.2178 26.343 16.936 26.0612C16.6542 25.7794 16.4959 25.3972 16.4959 24.9987C16.4959 24.6002 16.6542 24.218 16.936 23.9362L23.3748 17.5H4.99976C4.60193 17.5 4.2204 17.3419 3.9391 17.0606C3.65779 16.7793 3.49976 16.3978 3.49976 16C3.49976 15.6022 3.65779 15.2206 3.9391 14.9393C4.2204 14.658 4.60193 14.5 4.99976 14.5H23.3748L16.9385 8.05998C16.6567 7.77818 16.4984 7.39599 16.4984 6.99747C16.4984 6.59896 16.6567 6.21677 16.9385 5.93497C17.2203 5.65318 17.6025 5.49487 18.001 5.49487C18.3995 5.49487 18.7817 5.65318 19.0635 5.93497L28.0635 14.935C28.2034 15.0745 28.3143 15.2403 28.3899 15.4228C28.4655 15.6054 28.5043 15.801 28.5041 15.9986C28.5038 16.1962 28.4646 16.3918 28.3885 16.5741C28.3125 16.7565 28.2012 16.922 28.061 17.0612Z" fill="currentColor"/></svg>';
const arrowSvgPrev = arrowSvg.replace('<svg ', '<svg style="transform:rotate(180deg)" ');

/**
 * Module Init – parse JSON, build slides, mount Splide.
 * perPage 5, focus center; anchor scaling in CSS (Splide controls what’s visible).
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((section) => {
    const sliderEl = section.querySelector('.services-slider__slider.splide');
    const list = section.querySelector('.splide__list');

    if (!sliderEl || !list) return;

    try {
      section.querySelector('script')?.remove();

      const { data } = dJSON.parse(section.data);

      if (!Array.isArray(data) || !data.length) return;

      const fragment = document.createDocumentFragment();
      data.forEach((item) => {
        const { service_name: name = '', service_link: link = '', background } = item;
        const imgSrc = background?.url ?? (typeof background === 'string' ? background : '');
        const slide = document.createElement('div');
        slide.className = 'splide__slide';
        slide.innerHTML = /* html */ `
          <a href="${link}" class="services-slider__item">
            ${imgSrc ? `<img src="${imgSrc}" alt="" role="presentation" aria-hidden="true">` : ''}
            <h2 class="services-slider__item__title">${name}</h2>
          </a>
        `;
        fragment.appendChild(slide);
      });
      list.appendChild(fragment);

      const splide = new Splide(sliderEl, {
        type: 'loop',
        perPage: 5,
        perMove: 1,
        gap: 20,
        height: 370,
        focus: 'center',
        padding: '15px',
        trimSpace: 'move',
        arrows: true,
        pagination: true,
        speed: 200,
        rewindSpeed: 200,
        breakpoints: {
          1400: {
            perPage: 3,
          },
          1024: {
            perPage: 2,
          },
          768: {
            perPage: 1,
        
          },
        },
      });

      function repositionNav() {
        const arrows = sliderEl.querySelector('.splide__arrows');
        const pagination = sliderEl.querySelector('.splide__pagination');
        const prevBtn = sliderEl.querySelector('.splide__arrow--prev');
        const nextBtn = sliderEl.querySelector('.splide__arrow--next');
        if (!arrows) return;
        if (pagination && nextBtn) arrows.insertBefore(pagination, nextBtn);
        if (prevBtn) prevBtn.innerHTML = arrowSvgPrev;
        if (nextBtn) nextBtn.innerHTML = arrowSvg;
      }

      splide.mount();
      repositionNav();

      splide.on('resize updated', () => {
        requestAnimationFrame(() => {
          repositionNav();
        });
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
